import { ShieldCheck, Clock3, MapPin, HeadphonesIcon } from 'lucide-react';
import './About.css';

const features = [
  { icon: <ShieldCheck size={22} />, title: 'Siguri e Plotë', desc: 'Çdo makinë e siguruar dhe e kontrolluar rregullisht.' },
  { icon: <Clock3 size={22} />,      title: 'Shërbim 24/7',   desc: 'Disponueshëm çdo orë, çdo ditë të vitit.' },
  { icon: <MapPin size={22} />,      title: 'Dorëzim Kudo',   desc: 'Deri te dera juaj — aeroport, hotel, shtëpi.' },
  { icon: <HeadphonesIcon size={22} />, title: 'Support Pro', desc: 'Ekip i dedikuar gjatë gjithë periudhës së qirasë.' },
];

export default function About() {
  return (
    <section id="about" className="about">
      <div className="container about__grid">
        <div className="about__left">
          <span className="about__label">Kush Jemi</span>
          <h2 className="about__title">
            Rremi<br />
            <em>Rent a Car</em>
          </h2>
          <p className="about__text">
            Me mbi 10 vite eksperiencë, Rremi Rent a Car është zgjedhja e parë
            për klientët që kërkojnë cilësi, besueshmëri dhe çmime të drejta
            në të gjithë Kosovën.
          </p>
          <p className="about__text">
            Flota jonë moderne përfshin makina ekonomike, premium dhe SUV —
            gati për çdo lloj udhëtimi.
          </p>

          <div className="about__stats">
            <div className="about__stat">
              <strong>50+</strong><span>Makina</span>
            </div>
            <div className="about__stat">
              <strong>10+</strong><span>Vite</span>
            </div>
            <div className="about__stat">
              <strong>1000+</strong><span>Klientë</span>
            </div>
          </div>
        </div>

        <div className="about__right">
          {features.map((f, i) => (
            <div key={i} className="about__feature">
              <div className="about__feature-icon">{f.icon}</div>
              <div>
                <h4 className="about__feature-title">{f.title}</h4>
                <p className="about__feature-desc">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}